import classNames from "classnames";

import { Header } from "../../components/header/header";
import { PageSupport } from "../../components/utilities/page-support";

import "../../styles/branches.css";

export const MbecudaBranches = () => {
    return (
        <div className="f-pg">
            <PageSupport />
            <Header pageTitle={"Mbecuda Branches"} />
            <div className={classNames('branch-bx')}>
                <div className="branch-unit">
                    <div className="pg-cap">{"MBECUDA BAFOUSSAM"}</div>
                    <img src="/images/Bafoussam.jpeg" className="br-pic" />
                    <div className="branch-info">
                        <p>MBECUDA Bafoussam is the branch that hosts members who are resident in and around Bafoussam and the West Region.</p>
                        <p>Meeting dates are on the first Sunday of every month, at <strong>Marché B</strong>, from 3pm to 5pm.</p>
                        <p>Meeting activities include activities geared towards village development. Every meeting day, a member, designated during the last meeting shall be in charge of providing refreshment to the meeting.</p>

                    </div>
                </div>
            </div>
        </div>
    );
}